import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

import { AuthGuardService } from './services'

import { AppLoaderComponent } from './components/_common/app-loader/app-loader.component'
import { CategoriesComponent } from './pages/categories/categories.component'
import { CategoryComponent } from './pages/category/category.component'
import { CheckoutComponent } from './pages/checkout/checkout.component'
import { CheckoutsComponent } from './pages/checkouts/checkouts.component'
import { CompanySettingsComponent } from './pages/company-settings/company-settings.component'
import { DepotComponent } from './pages/depot/depot.component'
import { DepotsComponent } from './pages/depots/depots.component'
import { HomeComponent } from './pages/home/home.component'
import { NotFoundComponent } from './pages/not-found/not-found.component'
import { PrintInventoryDetailComponent } from './pages/print-inventory-detail/print-inventory-detail.component'
import { PrintInventoryExportsComponent } from './pages/print-inventory-exports/print-inventory-exports.component'
import { UserComponent } from './pages/user/user.component'
import { UsersComponent } from './pages/users/users.component'
import { ProductComponent } from './pages/product/product.component'
import { ProductMovePackComponent } from './pages/product-move-pack/product-move-pack.component'
import { ProductMovePacksComponent } from './pages/product-move-packs/product-move-packs.component'
import { ProductsComponent } from './pages/products/products.component'
import { StockOperationListComponent } from './pages/stock-operation-list/stock-operation-list.component'
import { StockTransferPageComponent } from './pages/stock-transfer-page/stock-transfer-page.component'
import { SupplierComponent } from './pages/supplier/supplier.component'
import { SuppliersComponent } from './pages/suppliers/suppliers.component'
import { CanDeactivateGuardService } from './services/can-deactivate-guard.service'
import { InstitutionComponent } from './pages/institution/institution.component'
import { InstitutionsComponent } from './pages/institutions/institutions.component'
import { ProductFormComponent } from './components/product-components/product-form/product-form.component'
import { ProductDepotsFormComponent } from './components/product-components/product-depots-form/product-depots-form.component'
import { ProductMovesListComponent } from './components/product-components/product-moves-list/product-moves-list.component'
import { ProductImagesComponent } from './components/product-components/product-images/product-images.component'
import { ProductFilesComponent } from './components/product-components/product-files/product-files.component'
import { ProductCategoriesComponent } from './components/product-components/product-categories/product-categories.component'
import { ProductTemplateSelectionComponent } from './components/product-components/product-template-selection/product-template-selection.component'
import { ProductPackingComponent } from './components/product-components/product-packing/product-packing.component'
import { ProductAutomaticOrderingComponent } from './components/product-components/product-automatic-ordering/product-automatic-ordering.component'
import { WizardComponent } from './pages/plug-play/pages/wizard/wizard.component'
import { Step1Component } from './pages/plug-play/pages/step1/step1.component'
import { Step2Component } from './pages/plug-play/pages/step2/step2.component'
import { Step3Component } from './pages/plug-play/pages/step3/step3.component'
import { Step5Component } from './pages/plug-play/pages/step5/step5.component'
import { Step4Component } from './pages/plug-play/pages/step4/step4.component'
import { Step6Component } from './pages/plug-play/pages/step6/step6.component'
import { Step7Component } from './pages/plug-play/pages/step7/step7.component'
import { Step8Component } from './pages/plug-play/pages/step8/step8.component'
import { Step3EditNewUserComponent } from './pages/plug-play/pages/step3-edit-new-user/step3-edit-new-user.component'
import { Step7ImportComponent } from './pages/plug-play/pages/step7-import/step7-import.component'
import { Step7ResultComponent } from './pages/plug-play/pages/step7-result/step7-result.component'
import { ProductPurchaseOrderCreationComponent } from './pages/product-purchase-order-creation/product-purchase-order-creation.component'
import { ProductPurchaseOrderCreationHsComponent } from './pages/product-purchase-order-creation-hs/product-purchase-order-creation-hs.component'
import { ProductPurchaseOrderForkComponent } from './pages/product-purchase-order-fork/product-purchase-order-fork.component'
import { PurchaseOrdersComponent } from './pages/purchase-orders/purchase-orders.component'
import { PurchaseOrderItemsComponent } from './pages/purchase-order-items/purchase-order-items.component'
import { PurchaseOrderCheckoutComponent } from './pages/purchase-order-checkout/purchase-order-checkout.component'
import { StatsComponent } from './pages/stats/stats.component'
import { AutomaticOrdersComponent } from './pages/automatic-orders/automatic-orders.component'

export const routes: Routes = [
  {
    path: 'automatic-orders',
    canActivate: [AuthGuardService],
    component: AutomaticOrdersComponent,
    data: { title: 'title.automatic-orders' },
  },
  {
    path: 'external-login',
    canActivate: [AuthGuardService],
    component: HomeComponent,
    data: { title: 'title.external-login' },
  },
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: 'categories',
    canActivate: [AuthGuardService],
    component: CategoriesComponent,
    data: { title: 'title.categories' },
  },
  {
    path: 'categories',
    canActivate: [AuthGuardService],
    component: CategoriesComponent,
    data: { title: 'title.category' },
  },
  {
    path: 'category',
    canActivate: [AuthGuardService],
    canDeactivate: [CanDeactivateGuardService],
    component: CategoryComponent,
    data: { title: 'title.category' },
  },
  {
    path: 'category/:id',
    canActivate: [AuthGuardService],
    canDeactivate: [CanDeactivateGuardService],
    component: CategoryComponent,
    data: { title: 'title.category-id', hasId: true },
  },
  {
    path: 'surgery',
    canActivate: [AuthGuardService],
    canDeactivate: [CanDeactivateGuardService],
    component: CheckoutComponent,
    data: { title: 'title.surgery' },
  },
  {
    path: 'surgery/:id',
    canActivate: [AuthGuardService],
    canDeactivate: [CanDeactivateGuardService],
    component: CheckoutComponent,
    data: { title: 'title.surgery-id', hasId: true },
  },
  {
    path: 'surgeries',
    canActivate: [AuthGuardService],
    component: CheckoutsComponent,
    data: { title: 'title.surgeries' },
  },
  {
    path: 'company',
    canActivate: [AuthGuardService],
    canDeactivate: [CanDeactivateGuardService],
    component: CompanySettingsComponent,
    data: { title: 'title.company' },
  },
  {
    path: 'depot',
    canActivate: [AuthGuardService],
    canDeactivate: [CanDeactivateGuardService],
    component: DepotComponent,
    data: { title: 'title.depot' },
  },
  {
    path: 'depot/:id',
    canActivate: [AuthGuardService],
    canDeactivate: [CanDeactivateGuardService],
    component: DepotComponent,
    data: { title: 'title.depot-id', hasId: true },
  },
  { path: 'depots', canActivate: [AuthGuardService], component: DepotsComponent, data: { title: 'title.depots' } },
  { path: 'home', canActivate: [AuthGuardService], component: HomeComponent, data: { title: 'title.home' } },
  {
    path: 'institution',
    canActivate: [AuthGuardService],
    canDeactivate: [CanDeactivateGuardService],
    component: InstitutionComponent,
    data: { title: 'title.institution' },
  },
  {
    path: 'institution/:id',
    canActivate: [AuthGuardService],
    canDeactivate: [CanDeactivateGuardService],
    component: InstitutionComponent,
    data: { title: 'Úprava zařízení', hasId: true },
  },
  {
    path: 'institutions',
    canActivate: [AuthGuardService],
    component: InstitutionsComponent,
    data: { title: 'title.institutions' },
  },
  { path: 'loading', component: AppLoaderComponent, data: { title: 'title.loading' } },
  {
    path: 'my/:profile',
    canActivate: [AuthGuardService],
    canDeactivate: [CanDeactivateGuardService],
    component: UserComponent,
    data: { title: 'title.my-profile' },
  },
  {
    path: 'inventory-detail/:id',
    canActivate: [AuthGuardService],
    component: PrintInventoryDetailComponent,
    data: { title: 'title.inventory-detail-id', hasId: true },
  },
  {
    path: 'inventory-exports',
    canActivate: [AuthGuardService],
    component: PrintInventoryExportsComponent,
    data: { title: 'title.inventory-exports' },
  },
  {
    path: 'stats',
    canActivate: [AuthGuardService],
    component: StatsComponent,
    data: { title: 'title.stats' },
  },
  {
    path: 'purchase-order',
    canActivate: [AuthGuardService],
    canDeactivate: [CanDeactivateGuardService],
    component: ProductPurchaseOrderCreationComponent,
    data: { title: 'title.purchase-order-creation' },
  },
  {
    path: 'purchase-order-hs',
    canActivate: [AuthGuardService],
    canDeactivate: [CanDeactivateGuardService],
    component: ProductPurchaseOrderCreationHsComponent,
    data: { title: 'title.purchase-order-creation-hs' },
  },
  {
    path: 'purchase-order-hs/:id',
    canActivate: [AuthGuardService],
    canDeactivate: [CanDeactivateGuardService],
    component: ProductPurchaseOrderCreationHsComponent,
    data: { title: 'title.purchase-order-detail-hs' },
  },
  {
    path: 'purchase-order-fork',
    canActivate: [AuthGuardService],
    canDeactivate: [CanDeactivateGuardService],
    component: ProductPurchaseOrderForkComponent,
    data: { title: 'title.purchase-order-fork' },
  },
  {
    path: 'purchase-order/:id',
    canActivate: [AuthGuardService],
    canDeactivate: [CanDeactivateGuardService],
    component: ProductPurchaseOrderCreationComponent,
    data: { title: 'title.purchase-order-detail' },
  },
  {
    path: 'purchase-orders',
    canActivate: [AuthGuardService],
    component: PurchaseOrdersComponent,
    data: { title: 'title.purchase-orders' },
  },
  {
    path: 'purchase-order-items',
    canActivate: [AuthGuardService],
    component: PurchaseOrderItemsComponent,
    data: { title: 'title.purchase-orders-on-the-way' },
  },
  {
    path: 'purchase-order-checkout',
    canActivate: [AuthGuardService],
    canDeactivate: [CanDeactivateGuardService],
    component: PurchaseOrderCheckoutComponent,
    data: { title: 'title.purchase-orders-checkout' },
  },
  {
    path: 'product',
    canActivate: [AuthGuardService],
    component: ProductComponent,
    data: { title: 'Nový produkt' },
    children: [
      { path: '', component: ProductTemplateSelectionComponent },
      {
        path: 'common',
        component: ProductFormComponent,
      },
      {
        path: 'categories',
        component: ProductCategoriesComponent,
      },
      {
        path: 'packing',
        component: ProductPackingComponent,
      },
    ],
  },
  {
    path: 'product/:id',
    canActivate: [AuthGuardService],
    component: ProductComponent,
    data: { title: 'title.product-id', hasId: true },
    children: [
      {
        path: '',
        component: ProductFormComponent,
      },
      {
        path: 'stock',
        component: ProductDepotsFormComponent,
      },
      {
        path: 'moves',
        component: ProductMovesListComponent,
      },
      {
        path: 'images',
        component: ProductImagesComponent,
      },
      {
        path: 'files',
        component: ProductFilesComponent,
      },
      {
        path: 'categories',
        component: ProductCategoriesComponent,
      },
      {
        path: 'packing',
        component: ProductPackingComponent,
      },
      {
        path: 'automatic-ordering',
        component: ProductAutomaticOrderingComponent,
      },
    ],
  },
  {
    path: 'product/:id/:tab',
    canActivate: [AuthGuardService],
    component: ProductComponent,
    data: { title: 'title.product-id-tab', hasId: true },
  },
  {
    path: 'products',
    canActivate: [AuthGuardService],
    canDeactivate: [CanDeactivateGuardService],
    component: ProductsComponent,
    data: { title: 'title.products' },
  },
  {
    path: 'product-move-pack/:id',
    canActivate: [AuthGuardService],
    component: ProductMovePackComponent,
    data: { title: 'title.product-move-pack-id', hasId: true },
  },
  {
    path: 'product-move-packs',
    canActivate: [AuthGuardService],
    component: ProductMovePacksComponent,
    data: { title: 'title.product-move-packs' },
  },
  {
    path: 'stock-batch-in',
    canActivate: [AuthGuardService],
    component: StockOperationListComponent,
    data: { title: 'title.stock-batch-in' },
  },
  {
    path: 'stock-batch-out',
    canActivate: [AuthGuardService],
    component: StockOperationListComponent,
    data: { title: 'title.stock-batch-out' },
  },
  {
    path: 'stock-batch-transfer',
    canActivate: [AuthGuardService],
    component: StockTransferPageComponent,
    data: { title: 'title.stock-batch-transfer' },
  },
  {
    path: 'supplier',
    canActivate: [AuthGuardService],
    canDeactivate: [CanDeactivateGuardService],
    component: SupplierComponent,
    data: { title: 'title.supplier' },
  },
  {
    path: 'supplier/:id',
    canActivate: [AuthGuardService],
    canDeactivate: [CanDeactivateGuardService],
    component: SupplierComponent,
    data: { title: 'title.supplier-id', hasId: true },
  },
  {
    path: 'suppliers',
    canActivate: [AuthGuardService],
    component: SuppliersComponent,
    data: { title: 'title.suppliers' },
  },
  {
    path: 'user',
    canActivate: [AuthGuardService],
    canDeactivate: [CanDeactivateGuardService],
    component: UserComponent,
    data: { title: 'title.user' },
  },
  {
    path: 'user/:id',
    canActivate: [AuthGuardService],
    canDeactivate: [CanDeactivateGuardService],
    component: UserComponent,
    data: { title: 'title.user-id', hasId: true },
  },
  { path: 'users', canActivate: [AuthGuardService], component: UsersComponent, data: { title: 'title.users' } },
  {
    path: 'plugplay',
    component: WizardComponent,
    canActivate: [AuthGuardService],
    data: { title: 'title.wizard' },
    children: [
      {
        path: 'step-1',
        component: Step1Component,
        data: { title: 'title.wizard.step-1' },
      },
      {
        path: 'step-2',
        component: Step2Component,
        data: { title: 'title.wizard.step-2' },
      },
      {
        path: 'step-3',
        data: { title: 'title.wizard.step-3' },
        children: [
          {
            path: 'list',
            component: Step3Component,
            data: { title: 'title.wizard.step-3' },
          },
          {
            path: 'new',
            component: Step3EditNewUserComponent,
            data: { title: 'title.wizard.step-3' },
          },
          {
            path: 'create',
            component: Step3EditNewUserComponent,
            data: { title: 'title.wizard.step-3' },
          },
          {
            path: 'edit/:id',
            component: Step3EditNewUserComponent,
            data: { title: 'title.wizard.step-3' },
          },
        ],
      },
      {
        path: 'step-4',
        component: Step4Component,
        data: { title: 'title.wizard.step-4' },
      },
      {
        path: 'step-5',
        component: Step5Component,
        data: { title: 'title.wizard.step-5' },
      },
      {
        path: 'step-6',
        component: Step6Component,
        data: { title: 'title.wizard.step-6' },
      },
      {
        path: 'step-7',
        data: { title: 'title.wizard.step-7' },
        children: [
          {
            path: 'check',
            component: Step7Component,
            data: { title: 'title.wizard.step-2' },
          },
          {
            path: 'import',
            component: Step7ImportComponent,
            data: { title: 'title.wizard.step-2' },
          },
          {
            path: 'result',
            component: Step7ResultComponent,
            data: { title: 'title.wizard.step-2' },
          },
        ],
      },
      {
        path: 'step-8',
        data: { title: 'title.wizard.step-8' },
        component: Step8Component,
      },
    ],
  },
  {
    path: '**',
    pathMatch: 'full',
    canActivate: [AuthGuardService],
    component: NotFoundComponent,
    data: { title: '404' },
  },
]

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
